/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Pagination dan get Data   |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

export const Pagination = {
    data() {
      return {
        items: [],
        tahun : '',
        indexed: '',
        search : "",
        searchPelatihan : "",
        searchPengaturanIuran : "",
        searchDataSKP : "",
        searchSertifikasi : "",
        searchDataPelatihanLms : "",
        searchPembayaran : "",
        idSertifikasi : "",
        status_pembayaran : '',
        pageSize : 10,
        currentPage :0,
        timeout: 0,
        pelatihan: {
            id_workshop_pelatihan : "",
        },
        pagination: {
            totalPages: 0
        },
        modelIdWorkshopPelatihan: '',
        id_pelatihan: '',
        searchPengajuanSkp : '',
        tipe: '',
        periode: '',
        id: '',
        tahun_daftar : '',
        startDate : '',
        endDate : '',
        modelIdSertifikasi : "",
        modelStatusPembayaran : '',
        currentPageDataPesertaSertifikasi : '',
        currentPagePengajuanSkp : 0,
        searchDataPesertaSertifikasi : '',
        no: 1,
        currentPageDataPesertaLms : 0,
        currentPageDataSkp : 0,
        idWorkshopPelatihan: ''
      };
    },
    watch: {
        search: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                var searchVar = vm.search.trimStart();
                var searchFinal = searchVar.trimEnd();

                vm.getData("0", vm.pageSize, searchFinal);
            }, 1000);
        },
        searchPengajuanSkp: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                var searchVar = vm.searchPengajuanSkp.trimStart();
                var searchFinal = searchVar.trimEnd();

                vm.getData("0", vm.pageSize, searchFinal,vm.tahun);
            }, 1000);
        },
        searchPelatihan: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData("0", vm.pageSize, vm.modelIdWorkshopPelatihan, vm.searchPelatihan);
            }, 1000);
        },
        searchPengaturanIuran : function(val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData(
                    "0",
                    vm.pageSize,
                    vm.searchPengaturanIuran,
                    vm.formFilter.periode,
                    ""
                );
            }, 1000);  
        },
        searchDataSKP: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData("0", vm.pageSize, vm.pelatihan.id_workshop_pelatihan, vm.searchDataSKP);
            }, 1000);
        },
        searchPengaturanIuran: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData("0", vm.pageSize, vm.searchPengaturanIuran, vm.formFilter.periode);
            }, 1000);
        },
        searchPembayaran: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData("0", vm.pageSize, vm.tipe, vm.searchPembayaran, vm.periode, vm.id);
            }, 1000);
        },
        searchPelatihanLms: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData(vm.searchPelatihanLms, vm.pageSize, vm.search, vm.statusPublish);
            }, 1000);
        },

        searchDataPelatihanLms: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                vm.getData("0", vm.pageSize, vm.id_pelatihan, vm.searchDataPelatihanLms);
            }, 1000);
        },

        searchSertifikasi: function (val) {
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                var searchVar = vm.ltrim(vm.searchSertifikasi)

                vm.getData("0", vm.pageSize,vm.modelIdSertifikasi, searchVar);
            }, 1000);
        },
        /**
         * 
         * Data Peserta Sertifikasi RPL
         */
        searchDataPesertaSertifikasi: function (val) {
            this.modelStatusPembayaran = 'default'
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                var searchVar = vm.ltrim(vm.searchDataPesertaSertifikasi)
                vm.getData(
                    0,
                    10,
                    'default',
                    vm.idSertifikasi,
                    vm.status_pembayaran,
                    vm.tahun_daftar,
                    vm.startDate,
                    vm.endDate
                );
            }, 1000);
        },
        currentPagePembayaran : function (val) {
            var page = val - 1;
            this.indexed = page * this.pageSize;
            this.getData(
                val - 1, 
                this.pageSize, 
                this.tipe,
                this.searchPelatihan,
                this.periode,
                this.id,
            );
            
           
        },
        currentPageDataSkp : function (val) {
            var page = val - 1;
            this.indexed = page * this.pageSize;
            this.getData(
                val - 1, 
                this.pageSize, 
                this.pelatihan.id_workshop_pelatihan,
                this.searchDataSKP,
            );
            
           
        },

        currentPagePembayaranOutstanding : function (val) {
            var page = val - 1;
            this.indexed = page * this.pageSize;
            this.getData(
                val - 1, 
                this.pageSize, 
                'pembayaran_outstanding',
                this.searchPembayaran,
                this.periode,
                this.id
            );
            
           
        },
        currentPageDataPesertaSertifikasi : function (val) {
            var page = val - 1;
            this.indexed = page * this.pageSize;
            this.getData(
                val - 1, 
                this.pageSize, 
                this.searchDataPesertaSertifikasi,
                this.idSertifikasi,
                this.status_pembayaran,
                this.tahun_daftar,
                this.startDate,
                this.endDate
            );
           
        },
        /**
         * 
         * End Data Peserta Sertifikasi RPl 
         */
        currentPage: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * this.pageSize;
            if(this.idTc != null || this.idTc != undefined) {
                this.getData(this.idTc,val - 1, this.pageSize, this.search);
                
            } else {

                this.getData(val - 1, this.pageSize, this.search);
            }
        },

        currentPagePengajuanSkp: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * this.pageSize;
            if(this.idTc != null || this.idTc != undefined) {
                this.getData(this.idTc,val - 1, this.pageSize, this.search,this.tahun);
                
            } else {

                this.getData(val - 1, this.pageSize, this.search,this.tahun);
            }
        },

        currentPageDataPesertaLms: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * this.pageSize;
            this.getData(this.idTc,val - 1, this.pageSize, this.search);
                
           
        }
    },
    methods: {
        hai(){
            alert("hai");
        },
        
        /**
         * 
         * Data Peserta Sertifikasi  
         */
        changePageSizeDataPesertaSertifikasi(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }
             
            
            this.getData(
                '0', 
                this.pageSize, 
                this.searchDataPesertaSertifikasi,
                this.idSertifikasi,
                this.status_pembayaran,
                this.tahun_daftar,
                this.startDate,
                this.endDate
            );

        },
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },

        changePageSizePengajuanSkp(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }
           
            this.getData("0", this.pageSize, this.searchPengajuanSkp,this.tahun);

        },
        
        changePageSize(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }
            if(this.idTc != null || this.idTc != undefined) {
                this.getData(this.idTc,val - 1, this.pageSize, this.search);

            } else {

                this.getData("0", vm.pageSize, vm.search);
            }
    
        },
    }
  };